import { render, staticRenderFns } from "./QuestionRadioTestWithSatisfied.vue?vue&type=template&id=b3bfb78e"
import script from "./QuestionRadioTestWithSatisfied.vue?vue&type=script&lang=js"
export * from "./QuestionRadioTestWithSatisfied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports